/**
 * CalcReadout — read-only display for a calculated criterion (age/BMI). The
 * recruiter doesn't answer it; the value is computed from earlier answers and
 * shown with its pass/fail verdict so it can be confirmed on the call. Shared by
 * every live prescreen surface (PrescreenRunner stepper + list, PrescreenAllPane,
 * AttemptDetailModal) so the computed-row look is identical everywhere.
 */
import { AlertTriangle, Calculator, Check } from 'lucide-react';
import { RuleVerdict } from '../../lib';

export default function CalcReadout({
  label, value, verdict, large,
}: { label: string; value: any; verdict: RuleVerdict; large?: boolean }) {
  const shown = value === undefined || value === null || value === '' ? '—' : String(value);
  return (
    <div>
      <div className={`mb-2 font-medium text-gray-900 dark:text-gray-100 ${large ? 'text-base' : 'text-sm'}`}>{label}</div>
      <div className="flex flex-wrap items-center gap-2">
        <span className="inline-flex items-center gap-1.5 rounded-lg bg-gray-100 px-3 py-2 text-lg font-semibold text-gray-900 dark:bg-gray-700 dark:text-gray-100">
          <Calculator className="h-4 w-4 text-primary-600 dark:text-primary-400" /> {shown}
        </span>
        {verdict === 'pass' && (
          <span className="inline-flex items-center gap-1 rounded-full bg-green-100 px-2 py-0.5 text-xs font-medium text-green-700 dark:bg-green-900/30 dark:text-green-300"><Check className="h-3 w-3" /> Meets</span>
        )}
        {verdict === 'fail' && (
          <span className="inline-flex items-center gap-1 rounded-full bg-red-100 px-2 py-0.5 text-xs font-medium text-red-700 dark:bg-red-900/30 dark:text-red-300"><AlertTriangle className="h-3 w-3" /> Does not meet</span>
        )}
        {verdict === 'unknown' && (
          <span className="rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-500 dark:bg-gray-700 dark:text-gray-300">Awaiting inputs</span>
        )}
      </div>
      <p className="mt-1 text-xs text-gray-400">Computed automatically from earlier answers</p>
    </div>
  );
}
